(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.admin-media', {
            url: '/media?page&sort&search',
            templateUrl: 'modules/system/media/media.html',
            controller: 'MediaController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.media.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                isPickerView: [function() {
                    return false;
                }],
                isMultiple: [function() {
                    return false;
                }]
            }
        });
    }
})();
